import React, { memo } from 'react';
import { MapPin } from 'lucide-react';
import './Footer.css';

const Footer = memo(() => {
  return (
    <footer className="footer">
      <div className="footer__top-line" />

      <div className="container">
        <div className="footer__content">
          <div className="footer__brand">
            <div className="footer__logo">
              <span className="footer__logo-icon">◆</span>
              <span className="footer__logo-text">Site Crafts</span>
            </div>
            <p className="footer__tagline">
              Professional web design for small & medium businesses.
              Get online, look great, win customers.
            </p>
            <div className="footer__location">
              <MapPin size={15} />
              <span>Proudly serving Nashville, TN and surrounding areas</span>
            </div>
            <p className="footer__location-sub">
              Based in Nashville, we work with local businesses across Middle Tennessee — and remotely with clients anywhere.
            </p>
          </div>

          <div className="footer__links">
            <div className="footer__col">
              <h4>Services</h4>
              <a href="#packages">Online Presence Pack</a>
              <a href="#packages">Brand + Website Pack</a>
              <a href="#packages">Restaurant Pro Pack</a>
              <a href="#packages">Full Business Suite</a>
            </div>
            <div className="footer__col">
              <h4>Company</h4>
              <a href="#process">How It Works</a>
              <a href="#packages">Pricing</a>
              <a href="#faq">FAQ</a>
              <a href="#get-started">Contact</a>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} Site Crafts. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
